import { Injectable } from '@angular/core';
import { BehaviorSubject, defer, Observable, of } from 'rxjs';
import { catchError, delay, filter, take, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
//import { environment } from '../../environments/environment.prod';
import { LocalStorageService } from 'ngx-localstorage';

export interface RefreshTokenResult {
  accessToken: string;
}

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  constructor(private http: HttpClient, public storage: LocalStorageService) {

  }

  tokenSubject$ = new BehaviorSubject<string | null>(null);

  token$ = this.tokenSubject$.pipe(
    filter((token) => token !== null),
    take(1)
  );

  refreshToken$: Observable<any> = defer(() => {
    if (this.tokenSubject$.value === null) {
      return this.token$;
    }
    // Defer allows us to easily execute some action when the Observable
    // is subscribed. Here, we set the current token to `null` until the
    // refresh operation is complete. This ensures no requests will be
    // sent with a known bad token.
    this.tokenSubject$.next(null);

    return this.refreshToken().pipe(
      tap((res) => {
        this.login();
        // this.tokenSubject$.next(res.accessToken);
      }),
      catchError((err) => {
        this.logout();
        throw err;
      })
    );
  });

  login() {
    const body = new HttpParams(
      {
        fromObject: {
          grant_type: 'password',
          client_secret: 'e19b9d78-3636-4ce4-b288-2d65fab62d5f',
          client_id: environment.CLIENT_ID,
          username: 'qb.integration',
          //username: 'u300111110',
          // password: environment.AZBG_PASSWORD,
          //password: 'Abc1Abcd22'
          password: 'wijcGPmC9WU!8'
        }
      }
    );

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    this.http.post(`${ environment.STS_SERVER }/protocol/openid-connect/token`, body, {
      headers,
      withCredentials: true
    }).subscribe((result: any) => {
      this.tokenSubject$.next(result.access_token);
      this.storage.set('x-token', result.access_token);
      this.storage.set('x-token-expires-in', new Date().getTime() + result.expires_in);
    });
  }

  get token(): string | null {
    return this.tokenSubject$.value;
  }

  authenticate(): void {
    this.tokenSubject$.next('someToken');
  }

  refreshToken(): Observable<RefreshTokenResult> {
    return of({
      accessToken: 'newToken',
    }).pipe(
      delay(0),
    );
  }

  logout(): void {
  }
}
